/**
 * Sets up the routing for all admin views relating to the User resource.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import cert routes
import CourseCertificateRouter from '../courseCertificate/CourseCertificateRouter.js.jsx';
import ModuleCertificateRouter from '../moduleCertificate/ModuleCertificateRouter.js.jsx';

class MyCertificates extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute login={true} path="/my-certificates">
          <ModuleCertificateRouter/>
        </YTRoute>
        <YTRoute login={true} path="/my-certificates/courses">
          <CourseCertificateRouter/>
        </YTRoute>
      </Switch>
    )
  }
}

export default MyCertificates;



// WEBPACK FOOTER //
// modules/user/MyCertificatesRouter.js.jsx